"use client"

import { littleBeaverLogo, heavyWoodsLogo, birdiesClubhouseLogo, mashLogo, brunosLogo } from "./images"

const LogoCarousel = () => {
  const logos = [
    { id: 1, name: "Little Beaver", url: littleBeaverLogo },
    { id: 2, name: "Heavy Woods", url: heavyWoodsLogo },
    { id: 3, name: "Birdies Clubhouse", url: birdiesClubhouseLogo },
    { id: 4, name: "Mash", url: mashLogo },
    { id: 5, name: "Brunos", url: brunosLogo },
  ]

  // Duplicate logos to ensure seamless scrolling
  const duplicatedLogos = [...logos, ...logos, ...logos]

  // Inject animation CSS
  const styles = `
    @keyframes scroll {
      from { transform: translateX(0); }
      to { transform: translateX(-33.33%); } /* Moves by 1/3 of the full set width */
    }

    .animate-scroll {
      display: flex;
      width: max-content;
      animation: scroll 10s linear infinite;
      flex-wrap: nowrap; /* Prevent logos from wrapping */
    }
  `

  return (
    <>
      {/* Inject CSS */}
      <style>{styles}</style>

      <div className="w-full overflow-hidden bg-white py-16"> {/* Increased padding for a larger section */}
        <div className="relative w-full">
          <div className="animate-scroll">
            {duplicatedLogos.map((logo, index) => (
              <div
                key={`${logo.id}-${index}`}
                className="mx-12 flex items-center justify-center" /* Increased spacing */
                style={{ width: "180px", height: "100px", flexShrink: 0 }} /* Increased size */
              >
                <img
                  src={logo.url || "/placeholder.svg"}
                  alt={logo.name}
                  className="max-w-full max-h-full object-contain"
                  style={{ width: "100%", height: "100%" }} /* Ensures full scaling */
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default LogoCarousel
